import { SectionError, SectionLoading } from '@/components/section-state';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { formatCurrency, formatNumber, getQualityGapCount } from './formatting';
import type { UsageUserRow } from './types';

export const UsageUserTable = ({
  users,
  isLoading,
  isError,
  error,
  onRetry,
  onUserFilter,
}: {
  users: UsageUserRow[];
  isLoading: boolean;
  isError: boolean;
  error: unknown;
  onRetry: () => void;
  onUserFilter: (user: UsageUserRow) => void;
}) => (
  <Card>
    <CardHeader>
      <CardTitle>Notendur</CardTitle>
      <CardDescription>Kostnaður og atburðir eftir notanda</CardDescription>
    </CardHeader>
    <CardContent>
      {isLoading && <SectionLoading label="Sæki notendur" />}
      {isError && <SectionError title="Notendur hlóðust ekki" error={error} onRetry={onRetry} />}
      {!isLoading && !isError && users.length === 0 && (
        <div className="flex min-h-28 items-center justify-center rounded-md border border-dashed text-muted-foreground text-sm">
          Engin gögn fundust fyrir valið tímabil.
        </div>
      )}
      {!isLoading && !isError && users.length > 0 && (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Notandi</TableHead>
              <TableHead>Stofa</TableHead>
              <TableHead className="text-right">Heildarkostnaður</TableHead>
              <TableHead className="text-right">Atburðir</TableHead>
              <TableHead className="text-right">Gagnagöt</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {users.map((user) => {
              const name = user.name || user.email || 'Óþekktur notandi';
              return (
                <TableRow key={user.user_id ?? user.email ?? name}>
                  <TableCell>
                    <Button
                      type="button"
                      variant="ghost"
                      className="-ml-3 h-auto justify-start py-2 text-left"
                      aria-label={`Sía eftir ${name}`}
                      onClick={() => onUserFilter(user)}
                    >
                      <span className="flex flex-col items-start">
                        <span>{name}</span>
                        {user.email && <span className="font-normal text-muted-foreground text-xs">{user.email}</span>}
                      </span>
                    </Button>
                  </TableCell>
                  <TableCell>{user.clinic_name || 'Óþekkt stofa'}</TableCell>
                  <TableCell className="text-right">{formatCurrency(user.total_cost_usd)}</TableCell>
                  <TableCell className="text-right">{formatNumber(user.total_events)}</TableCell>
                  <TableCell className="text-right">{formatNumber(getQualityGapCount(user))}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </CardContent>
  </Card>
);
